'use client';
import { useQuery } from '@tanstack/react-query';
import { fetchOffers } from '@eliadmin/core/src/api/jobportal/offers-api';
import { buildJobOffersQuery } from '@eliadmin/core/src/utils/jobportal-offers-query';
import { JobOfferCardSmall } from '../../components/jobportal/job-offer-card-small';
import { JobOfferCardSmallSkeleton } from '../../components/jobportal/job-offer-card-small-skeleton';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { GoArrowRight } from 'react-icons/go';
import Link from '@eliadmin/core/src/components/link';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
export function DualEducation({ locale }: { locale: string }) {
  const { me, isInitialized } = useCustomerStore();
  const { data: offers, isLoading: isLoadingOffers } = useQuery({
    queryKey: ['dual-education-offers', locale, me?.authToken ?? null],
    queryFn: () =>
      fetchOffers({
        locale,
        authToken: me?.authToken,
        query: {
          'order[]': ['desc', 'desc'],
          'orderBy[]': ['topped_up_to', 'published_at'],
          results: 8,
          page: 1,
          ...buildJobOffersQuery({
            is_paid: true,
            dual_education: true,
          }),
        },
      }),
    enabled: isInitialized,
  });

  return (
    <section id="dual-education" className={cn('custom-section', 'py-8 sm:py-12 lg:py-16')}>
      <div className="custom-container flex flex-col gap-4">
        <div className="flex w-full items-center justify-between px-6 md:px-0">
          <h2 className="text-2xl font-bold text-foreground sm:text-3xl">Duálne vzdelávanie</h2>
          <div className="hidden md:block">
            <Button asChild>
              <Link
                prefetchOnHover
                href={'/ponuky?order=desc&orderBy=published_at&dual_education=true'}
              >
                <p>Všetky duálne vzdelávania</p>
                <GoArrowRight size={24} className="text-white" />
              </Link>
            </Button>
          </div>
        </div>
        <div className="grid w-full grid-cols-1 items-center justify-center gap-0 gap-y-4 sm:grid-cols-2 md:gap-2 lg:grid-cols-3 xl:grid-cols-4">
          {!isInitialized || isLoadingOffers
            ? // Show 8 skeleton cards while loading or when not initialized
              Array.from({ length: 8 }).map((_, index) => <JobOfferCardSmallSkeleton key={index} />)
            : offers?.data?.map(offer => <JobOfferCardSmall offer={offer} key={offer.slug} />)}
        </div>
        <div className="block w-full px-6 sm:hidden">
          <Button asChild className="mt-8 w-full">
            <Link
              prefetchOnHover
              href={'/ponuky?order=desc&orderBy=published_at&dual_education=true'}
            >
              <p>Všetky duálne vzdelávania</p>
              <GoArrowRight size={24} className="text-white" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
